import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';

export interface ModalProps {
    onClose: () => void;
    children: React.ReactNode;
}

export const Modal: FC<ModalProps> = ({ onClose, children }) => {
    return (
        <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="fixed inset-0 bg-white-fade opacity-50"></div>

            <div className="flex items-center justify-center min-h-screen">
                <div className="bg-white rounded-lg p-8 shadow-lg relative w-full max-w-lg w-medium">
                    {children}

                    <button
                        className="absolute top-0 right-0 mt-5 mr-6 text-2xl font-semibold text-brand"
                        onClick={onClose}
                    >
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Modal;
